"use strict";

import {findIn, findAllIn, addClass, on, removeClass, removeAttribute, setAttribute, hasClass} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";

export function init () {
    onFind('.js-scrolling-area', function (container) {
        let prevButton = findAllIn('.js-scrolling-area__prev', container),
            nextButton = findAllIn('.js-scrolling-area__next', container),
            scrollArea = findIn('.js-scrolling-area__area', container);


        let items = findAllIn('.js-scrolling-area__item', container);
        const scrollWidth = getScrollWidth(items[0]);
        const offset = items[0].getBoundingClientRect().left;
        let lastItemActive = false;

        //initial scroll position 0
        scrollArea.scrollLeft = 0;

        nextButton.map((button) => {
            on('click', function () {
                scrollTo(scrollArea, scrollArea.scrollLeft + scrollWidth)
            }, button);
        });

        prevButton.map((button) => {
            if(scrollArea.scrollLeft === 0) {
                setAttribute('disabled', true, button);
            } else {
                removeAttribute('disabled', button);
            }

            on('click', function () {
                if (lastItemActive) {
                    scrollTo(scrollArea, scrollArea.scrollLeft - scrollWidth/2)
                } else {
                    scrollTo(scrollArea, scrollArea.scrollLeft - scrollWidth)
                }
            }, button);
        });

        let currentScroll = 0;
        on('scroll', function (evt) {
            nextButton.map((button) => removeAttribute('disabled', button));
            lastItemActive = false;

            if(scrollArea.scrollLeft === 0) {
                prevButton.map((button) => setAttribute('disabled', true, button));
            } else {
                prevButton.map((button) => removeAttribute('disabled', button));
            }


            // if (currentScroll <= scrollArea.scrollLeft) {
            //     items.map((item, index) => {
            //         if (item.getBoundingClientRect().left < scrollWidth && item.getBoundingClientRect().left > offset) {
            //             if (items[index - 1]) {
            //                 removeClass('is-active', items[index - 1]);
            //             }
            //
            //             addClass('is-active', item);
            //         }
            //     });
            // } else {
            //     items.map((item, index) => {
            //         if (item.getBoundingClientRect().left >= scrollWidth && item.getBoundingClientRect().left <= container.getBoundingClientRect().width) {
            //             if (items[index - 1]) {
            //                 addClass('is-active', items[index - 1]);
            //             }
            //
            //             removeClass('is-active', item);
            //         }
            //     });
            // }
            // currentScroll = scrollArea.scrollLeft;

            items.map((item, index) => {
                if (item.getBoundingClientRect().left <= scrollWidth && item.getBoundingClientRect().left >= offset) {
                    if (items[index - 1]) {
                        removeClass('is-active', items[index - 1]);
                    }

                    addClass('is-active', item);

                    if (items.slice(-1)[0] === item) {
                        nextButton.map((button) => setAttribute('disabled', true, button));
                        lastItemActive = true;
                    }

                } else if(item.getBoundingClientRect().left >= scrollWidth && item.getBoundingClientRect().left <= container.getBoundingClientRect().width) {
                    if (items[index - 1]) {
                        addClass('is-active', items[index - 1]);
                    }

                    removeClass('is-active', item);
                }
            });
            }, scrollArea);

        updateScrollWidth(items[0]);
    });
}

function scrollTo(scrollArea, scroll) {
    try {
        scrollArea.scroll({
            left: scroll,
            behavior: 'smooth'
        });
    } catch (e) {
        scrollArea.scrollLeft = scroll;
    }
}

function getScrollWidth(item) {
    return item.getBoundingClientRect().width;
}

function updateScrollWidth(item) {
    let delay = 250,
        throttled = false;

    window.addEventListener('resize', function() {
        if (!throttled) {
            getScrollWidth(item);
            throttled = true;
            setTimeout(function() {
                throttled = false;
            }, delay);
        }
    });
}